module.exports = __webpack_public_path__ + "static/assets/6e8d09a1b0507f46d223d29a485672f8.svg";